import React from "react";
import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

import { Tooltip } from "./Tooltip";

const useStyles = makeStyles()((theme: Theme) => ({
    icon: {
        color: theme.palette.emteria.text.secondary,
    },
}));

type Props = {
    /**
     * Font Awesome classes, including the style prefix (`fa-solid fa-user`).
     */
    icon: string;
    /**
     * Names what the icon stands for, since the icon has no text next to it.
     */
    tooltip: React.ReactNode;
    className?: string;
};

/**
 * An icon on its own that says what kind of thing something is or where it comes from (a file type, a file source, a
 * membership type), not whether it is fine. It is grey so it stays quieter than the status colours in the same row.
 */
export const IndicatorIcon = ({ icon, tooltip, className }: Props) => {
    const { classes, cx } = useStyles();

    return (
        <Tooltip title={tooltip}>
            <i className={cx(icon, classes.icon, className)} />
        </Tooltip>
    );
};
